import React, { createContext, useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { getApplicationSize, getApplicationSizeMediaQueryLists, } from '@anwb/browser';
const ApplicationSizeContext = createContext(null);
/**
 * This hook was causing a lot of issues within applications, often the ApplicationSizeProvider was not used. Because
 * of this, this hook tries to access the ApplicationSizeContext, if it is not available it will use the hook
 * useViewportBreakpoint to get the current size.
 */
export const useApplicationSize = () => {
    const context = useContext(ApplicationSizeContext);
    const hook = useViewportBreakpoint({ ignoreChange: context !== null });
    useEffect(() => {
        if (context === null && process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`The ApplicationSizeProvider is missing in the tree, please add one as a direct child of the ThemeProvider.`);
        }
    }, [context]);
    if (context === null) {
        return hook;
    }
    return context;
};
const useViewportBreakpoint = ({ ignoreChange = false, renderingMode = 'csr', }) => {
    const theme = useTheme();
    const [viewportBreakpoint, setViewportBreakpoint] = useState(renderingMode === 'ssr' ? 'small' : getApplicationSize({ theme }));
    useEffect(() => {
        if (ignoreChange) {
            return () => { };
        }
        const checkMatch = () => {
            setViewportBreakpoint(getApplicationSize({ theme }));
        };
        getApplicationSizeMediaQueryLists({ theme }).forEach(({ mediaQueryList }) => mediaQueryList.addEventListener('change', checkMatch));
        checkMatch();
        return () => {
            getApplicationSizeMediaQueryLists({ theme }).forEach(({ mediaQueryList }) => mediaQueryList.removeEventListener('change', checkMatch));
        };
    }, [theme, ignoreChange]);
    return viewportBreakpoint;
};
const ApplicationSizeProvider = ({ className, children, renderingMode = 'csr', }) => {
    const size = useViewportBreakpoint({ renderingMode });
    return (React.createElement(ApplicationSizeContext.Provider, { value: size },
        React.createElement("div", { className: className }, children)));
};
export default ApplicationSizeProvider;
//# sourceMappingURL=Provider.js.map